import CryptoJS from 'crypto-js'

export const createHmacDigest = string => {
  var hash = CryptoJS.HmacSHA256(
    string,
    process.env.REACT_APP_SECRET_KEY_FOR_HASHING
  )
  return hash.toString(CryptoJS.enc.Hex)
}
